export default __webpack_public_path__ + "navigation-examples-basic-v1-1200-73079c879b6cc323f8bc29949d6808c0.webp";